import axios, { AxiosError } from 'axios';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { isCollectionKimeraError } from '../utils/isCollectionKimeraError';

export const addToCollection = async ({ collectionId, resourceType, resourceId }): Promise<void> => {
    try {
        await axios.post(pathfinder('create_collection_item', { id: collectionId }), {
            resource_id: resourceId,
            resource_type: resourceType,
        });
    } catch (error) {
        if (!isCollectionKimeraError(error)) {
            logger.error(error as Error, {
                description: 'Failed to add resource to collection',
                collectionId,
                resourceType,
                resourceId,
                errorResponse: error instanceof AxiosError ? error.response?.data : undefined,
            });
        }
        throw error;
    }
};
